import { Types } from './types';

export type ModalPriorityState = number[];
const initialState: ModalPriorityState = [];

export function modalPriorityReducer(
  state: ModalPriorityState = initialState,
  action: { type: Types; payload: { priority: number } }
): ModalPriorityState {
  switch (action.type) {
    case Types.APPEND_MODAL_PRIORITY: {
      const { priority } = action.payload;
      if (state.includes(priority)) return state;
      return [...state, priority]; // No sort needed
    }
    case Types.REMOVE_MODAL_PRIORITY: {
      const { priority } = action.payload;
      const newState = state.filter((p) => p !== priority);
      return newState.length ? newState : initialState; // Reset to empty if no priorities remain
    }
    default:
      return state;
  }
}
